import '@fontsource/libre-baskerville/latin.css';
import '@fontsource/libre-baskerville/latin-ext.css';
import '@fontsource/libre-baskerville/latin-400.css';
import '@fontsource/libre-baskerville/latin-400-italic.css';
import '@fontsource/libre-baskerville/latin-700.css';
import '@fontsource/libre-baskerville/latin-ext-400.css';
import '@fontsource/libre-baskerville/latin-ext-400-italic.css';
import '@fontsource/libre-baskerville/latin-ext-700.css';

import '@fontsource/karla/latin-200.css';
import '@fontsource/karla/latin-200-italic.css';
import '@fontsource/karla/latin-ext-200.css';
import '@fontsource/karla/latin-ext-200-italic.css';
import '@fontsource/karla/latin-300.css';
import '@fontsource/karla/latin-300-italic.css';
import '@fontsource/karla/latin-ext-300.css';
import '@fontsource/karla/latin-ext-300-italic.css';
import '@fontsource/karla/latin-400.css';
import '@fontsource/karla/latin-400-italic.css';
import '@fontsource/karla/latin-ext-400.css';
import '@fontsource/karla/latin-ext-400-italic.css';
import '@fontsource/karla/latin-500.css';
import '@fontsource/karla/latin-500-italic.css';
import '@fontsource/karla/latin-ext-500.css';
import '@fontsource/karla/latin-ext-600-italic.css';
import '@fontsource/karla/latin-600.css';
import '@fontsource/karla/latin-600-italic.css';
import '@fontsource/karla/latin-ext-600.css';
import '@fontsource/karla/latin-ext-600-italic.css';
import '@fontsource/karla/latin-700.css';
import '@fontsource/karla/latin-700-italic.css';
import '@fontsource/karla/latin-ext-700.css';
import '@fontsource/karla/latin-ext-700-italic.css';
import '@fontsource/karla/latin-800.css';
import '@fontsource/karla/latin-800-italic.css';
import '@fontsource/karla/latin-ext-800.css';
import '@fontsource/karla/latin-ext-800-italic.css';
